module.exports = __webpack_public_path__ + "static/img/fefco204_2.d05f148.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/products/fefco204_2.png
// module id = At97
// module chunks = 0